import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";

import TeamCard from "./TeamCard";
import "./Team.scss";

//import {TeamFilter} from "../../common/queries/common_use_query"

const Team = ({Module, team_data}) => {

    //const{loading, error, data} = TeamFilter(category);

    var settings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                    dots:true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    dots:true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots:true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },

        ],
    };

    return (
        <React.Fragment>
            {team_data?.length > 0 && 
            <section className="team">
                <Container>
                    <Row>
                        <Col>
                            <div className="team-wrapper">
                                <h2>{Module?.title}</h2>

                                {team_data?.length > 0 && 
                                <Slider {...settings}>
                                    {team_data?.map((item, index) => {
                                        return(
                                            <TeamCard item={item?.team ? item?.team : item} />
                                        )
                                    })
                                    }
                                </Slider>
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            }
        </React.Fragment>
    );
};
export default Team;
